import { db, auth, firestorage } from "../Config";

export const fetchUsuario = async (email) => {
  let usuario = {};
  await db
    .collection("usuarios")
    .where("email", "==", email)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        usuario = doc.data()
      });
    })
    .catch((err) => {
      throw new Error(err);
    });
  return usuario;
};

export const fetchUser = async (email) => {
  return new Promise((resolve, reject) => {
    let usuario = {};
    db.collection("usuarios")
      .where("email", "==", email)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          usuario = doc.data();
        });
        resolve(usuario);
      })
      .catch((err) => {
        console.log('falta permiso', err)
        reject(err);
      });
  });
};

export const saveUser = (usuario) => {
  return new Promise((resolve, reject) => {
    // Ensure empresaId exists, if not, we can't save to the correct subcollection. 
    // Assuming usuario has empresaId.
    if (!usuario.empresaId) {
      reject(new Error("Falta empresaId para guardar el usuario"));
      return;
    }
    var usuariosRef = db.collection("empresas").doc(usuario.empresaId).collection("usuarios").doc(usuario.id);
    usuariosRef
      .set(usuario)
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const creaUsuario = (email, cargo, nombres, perfil, empresaId, uid) => {
  var usuario = {
    cargo: cargo,
    email: email,
    empresaId: empresaId,
    fecha: new Date(),
    nombres: nombres,
    perfil: perfil,
  };

  var usuariosRef = db.collection("empresas").doc(empresaId).collection("usuarios").doc(uid);
  usuariosRef
    .set(usuario) // Changed to set because we are using doc(uid)
    .then(() => { })
    .catch((err) => {
      console.log("error al guardar" + err);
    });
};



export const usiarioUploadImage = async (file) => {
  const storageRef = firestorage.ref();
  let pathFile = `firmas/${file.name}`;
  const fileRef = storageRef.child(pathFile);
  await fileRef.put(file);
  const fileUrl = await fileRef.getDownloadURL();
  return fileUrl;
};
